import React from 'react';
import appLogoWhite from 'assets/img/logo/icon_ehadj_white.svg';
import horizontalDots from 'assets/img/sidebar/pattern-dots-horizontal.svg';
import verticalDots from 'assets/img/sidebar/pattern-dots-vertical.svg';
import Locales from 'locales';
import { Urls } from 'data';

const AuthSidebar = () => {
  return (
    <aside className="relative flex h-[75px] w-full max-w-none overflow-hidden bg-[#0c3116] min-[521px]:h-[94px] lg:fixed lg:inset-y-0 lg:left-0 lg:h-dvh lg:w-[min(27vw,450px)] lg:max-w-[450px] lg:items-center lg:justify-center">
      <img
        className="pointer-events-none absolute left-0 top-0 h-auto w-[298px] opacity-25 lg:opacity-100"
        src={horizontalDots}
        alt=""
        aria-hidden="true"
      />

      <div className="absolute left-0 top-[19px] z-10 flex w-full items-center justify-center min-[521px]:top-7 lg:static lg:-translate-y-6 lg:flex-col lg:items-start lg:px-[16%]">
        <a href={Urls.base} className="flex items-center justify-center gap-2">
          <img className="h-9 w-9 max-w-none" src={appLogoWhite} title="eHadj logo" alt="eHadj-logo" />
          <span className="-mb-1 text-3xl font-bold text-white">eHadj</span>
        </a>
        <p className="mt-6 hidden max-w-[290px] text-2xl leading-[1.3] text-white lg:block">
          {Locales.auth.description}
        </p>
      </div>

      <img
        className="pointer-events-none absolute bottom-0 right-0 h-[112px] w-[104px] opacity-25 lg:opacity-100"
        src={verticalDots}
        alt=""
        aria-hidden="true"
      />
    </aside>
  );
};

export default AuthSidebar;
